import { useMediaQuery, Theme, Breakpoint } from "@mui/material";

export const useIsUpBreakpoint = (breakpoint: Breakpoint | number): boolean => useMediaQuery((theme: Theme) => theme.breakpoints.up(breakpoint));

export const useIsDownBreakpoint = (breakpoint: Breakpoint | number): boolean => useMediaQuery((theme: Theme) => theme.breakpoints.down(breakpoint));

export const useIsBetweenBreakpoint = (start: Breakpoint | number, end: Breakpoint | number): boolean => useMediaQuery((theme: Theme) => theme.breakpoints.between(start, end));
